// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

import type { ResourcesState } from 'commons/types/resourceTypes';

export const initialState: ResourcesState = {
  selectedResource: null,
};

const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    // Action name is inferred from the reducer key here:
    resourceSelectResource: (state, action) => {
      state.selectedResource = action.payload;
    },
  },
});

export const { resourceSelectResource } = resourcesSlice.actions;

export default resourcesSlice.reducer;
